module.exports = __webpack_public_path__ + "img/biaoqian_gangting.424d8ad2.png";